import React, { useState, useContext, useEffect } from "react";
import { Form } from "react-bootstrap";
import { Context } from "../../../auth/Context";
import endpoint from "../../../auth/endpoint";
import { SuccessAlert, ErrorAlert } from "../../../toasst/toast";

export const ChangePwdInApp = () => {
  const { user } = useContext(Context);
  const currentUser = user?.user;
  const userID = currentUser.id;

  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const passwordRegex = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@$!%*?&]).{6,}$/;

  // Validate inputs in realtime
  useEffect(() => {
    let newErrors = {};

    if (formData.currentPassword.trim().length === 0) {
      newErrors.currentPassword = "Current password is required";
    }

    if (formData.newPassword.trim().length === 0) {
      newErrors.newPassword = "New password is required";
    } else if (!passwordRegex.test(formData.newPassword)) {
      newErrors.newPassword = "Min 6 chars, include uppercase, number & special char";
    }

    if (formData.confirmPassword.trim().length === 0) {
      newErrors.confirmPassword = "Confirm password is required";
    } else if (formData.newPassword !== formData.confirmPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
  }, [formData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (Object.keys(errors).length > 0 || loading) {
      ErrorAlert("Please fix the validation errors before submitting");
      return;
    }

    if (formData.newPassword !== formData.confirmPassword) {
      ErrorAlert("New password and confirm password do not match");
      return;
    }

    setLoading(true);

    try {
      const res = await endpoint.put(`/user/update/password/${userID}`, {
        password: formData.currentPassword,
        new_password: formData.newPassword,
        confirm_password: formData.confirmPassword
      });

      if (res.status === 200) {
        SuccessAlert("Password changed successfully!");
        setFormData({ currentPassword: "", newPassword: "", confirmPassword: "" });
      }
    } catch (err) {
      console.error("Password change error:", err);
      
      if (err.response) {
        ErrorAlert(err.response.data.msg || "Failed to change password");
      } else if (err.request) {
        ErrorAlert("Network error. Please check your connection.");
      } else {
        ErrorAlert("An unexpected error occurred");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="page-header">
        <h3 className="page-title">User Info</h3>
      </div>
      <div className="card">
        <div className="card-header text-center">
          <h2 className="card-title mb-0">Change Password</h2>
        </div>
        <div className="card-body">
          <form className="forms-sample" onSubmit={handleSubmit}>
            {/* Full Name & Email */}
            <div className="row align-items-center">
              <div className="col-md-6">
                <Form.Group>
                  <label>Full Name</label>
                  <Form.Control
                    type="text"
                    value={`${currentUser.first_name} ${currentUser.last_name}`}
                    className="form-control"
                    readOnly
                    disabled
                  />
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group>
                  <label>Email Address</label>
                  <Form.Control
                    type="text"
                    value={currentUser.email}
                    className="form-control"
                    readOnly
                    disabled
                  />
                </Form.Group>
              </div>
            </div>

            {/* Current & New Password */}
            <div className="row align-items-center">
              <div className="col-md-6">
                <Form.Group>
                  <label>
                    Current Password <span className="text-danger">*</span>
                  </label>
                  <Form.Control
                    type="password"
                    value={formData.currentPassword}
                    onChange={(e) =>
                      setFormData({ ...formData, currentPassword: e.target.value })
                    }
                  />
                  {errors.currentPassword && (
                    <small className="text-danger">{errors.currentPassword}</small>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group>
                  <label>
                    New Password <span className="text-danger">*</span>
                  </label>
                  <Form.Control
                    type="password"
                    value={formData.newPassword}
                    onChange={(e) =>
                      setFormData({ ...formData, newPassword: e.target.value })
                    }
                  />
                  {errors.newPassword && (
                    <small className="text-danger">{errors.newPassword}</small>
                  )}
                </Form.Group>
              </div>
            </div>

            {/* Confirm & Submit */}
            <div className="row align-items-center mt-3">
              <div className="col-md-6">
                <Form.Group>
                  <label>
                    Confirm Password <span className="text-danger">*</span>
                  </label>
                  <Form.Control
                    type="password"
                    value={formData.confirmPassword}
                    onChange={(e) =>
                      setFormData({ ...formData, confirmPassword: e.target.value })
                    }
                  />
                  {errors.confirmPassword && (
                    <small className="text-danger">{errors.confirmPassword}</small>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-6 mt-4">
                <button
                  type="submit"
                  className="btn btn-gradient-primary w-100"
                  disabled={Object.keys(errors).length > 0 || loading}
                >
                  {loading ? "Changing Password..." : "Submit"}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ChangePwdInApp;